import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
  FormArray
} from '@angular/forms';

import { PlansService } from '../services/plans.service';
import { AuthenticationService } from '../services/authentication.service';
import { PlantypeService } from '../services/plantype.service';

@Component({
  selector: 'app-plans',
  templateUrl: './plans.component.html',
  styleUrls: ['./plans.component.css']
})
export class PlansComponent implements OnInit {
  pageTitle = 'Administrar Planes';

  myDate: Date;
  namePlan = '';
  typePlan = '';
  durationPlan = 0;
  planType: any[];
  show = '';
  minDate: Date;
  expDate: Date;

  formRef: FormGroup;

  constructor(
    private planService: PlansService,
    private authService: AuthenticationService,
    private plantypeService: PlantypeService,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.createForm();
    this.plantypeService
      .getTypePlan()
      .valueChanges()
      .subscribe(
        data => {
          this.planType = data;
        },
        error => {
          console.log(error);
        }
      );
    this.minDate = new Date();
    this.minDate.setDate(this.minDate.getDate());
  }

  createForm() {
    this.formRef = this.formBuilder.group({
      namePlan: ['', Validators.required],
      typePlan: ['', Validators.required],
      durationPlan: [''],
      expDate: ['']
    });
  }
  selectType(type) {
    this.durationPlan = 0;
    this.expDate = null;
    if (type === 'fecha') {
      console.log('valida fecha');
      const control = new FormControl('fecha');
      this.formRef.get('expDate').setValidators(Validators.required);
      this.formRef.get('durationPlan').clearValidators();
      control.reset({ value: 'fecha' });
      this.show = 'expDate';
    } else if (type === 'días') {
      console.log('valida duración');
      const control = new FormControl('días');
      this.formRef.get('expDate').clearValidators();
      this.formRef.get('durationPlan').setValidators([Validators.required, Validators.min(1)]);
      control.reset({ value: 'días' });
      this.show = 'durationPlan';
    }
  }
  saveSettings() {
    if (this.formRef.valid) {
      const pid = Date.now();
      this.myDate = new Date();
      this.authService.getStatus().subscribe(
        status => {
          let plan = {};
          if (this.show == 'expDate') {
            const expDate = this.expDate;
            expDate.setHours(23, 59, 59);
            plan = {
              pid: pid.toString(),
              name: this.namePlan,
              type: this.typePlan,
              creator: status.uid,
              date_creation: this.myDate,
              date_expiration: expDate.toString(),
              status: 'activo'
            };
          } else if (this.show == 'durationPlan') {
            plan = {
              pid: pid.toString(),
              name: this.namePlan,
              type: this.typePlan,
              durationPlan: this.durationPlan,
              creator: status.uid,
              date_creation: this.myDate,
              status: 'activo'
            };
          }
          this.planService
            .setPlan(plan)
            .then(() => {
              alert('Plan creado con éxito');
              this.cleanForm();
              this.show = '';
            })
            .catch(error => {
              console.log(error);
            });
        },
        error => {
          console.log(error);
        }
      );
    }
  }
  cleanForm() {
    this.createForm();
  }
}
